import React from 'react';
import CONSTANTS from '../../constants';
import Icon from './Icon';


const EditButton = (props) => {
	/*function sendDataToGTM(){
		  //event label remonte les données renseignées lors de Click sur CTA "afficher plus de garages à proximité"
					 window.dataLayer.push({
					  'pageName':"multicréneaux",  
					  'event': 'uaevent',  
					  'eventCategory': 'Content',  
					  'eventAction': "Display::MoreDealers",
					  'eventLabel': window.labels['Multi-creneaux_AfficherPlusGarages'] 
				 }); 
	   props.onClick();
	}*/
	return (
		props.span ?
		<div className="summary-edit" onClick={props.onClick} >
			<Icon Name="edit" />
			{props.Title && <span dangerouslySetInnerHTML={{ __html: (props.Title) }}></span>}


			{!props.Title && <span>{CONSTANTS.LABELS.common_v2_modify}</span>}
		</div>	
		:
		<button className="summary-edit" onClick={props.onClick} >
			<Icon Name="edit" />
			{props.Title && <span dangerouslySetInnerHTML={{ __html: (props.Title) }}></span>}


			{!props.Title && <span>{CONSTANTS.LABELS.common_v2_modify}</span>}
		</button>		
	)
}

export default EditButton;
